import { cssUtil } from "../../utils/cssUtil.js";
import { renderBackground } from "../commonStyles.js";

export async function renderSectionColumnWidget(context, widget, parent, override = null) {

    // <td class="section_column_widget">
    const container = context.document.createElement("div");
    container.classList.add("section_column_widget");

    const styles = getColumnStyles(context, widget);
    container.setAttribute("style", cssUtil.toStyleString(styles));
    container.setAttribute("data-widgetId", widget.uid);
    container.setAttribute("data-widgetType", widget.type);
    container.setAttribute("data-widgetParent", widget.parent);

    const breakpoint = context.currentBreakpoint;

    parent.appendChild(container);

    // Background
    renderColumnBackground(context, widget, container);

    // Render children
    const children = context.widgets.filter(w => w.parent === widget.uid);
    if (!children || !children.length) return container;

    for (const child of children) {
        const device = child?.properties?.[breakpoint];
        if (device?.visible === false) continue;

        const renderer = context.renderers[child.type];
        if (!renderer) continue;

        await renderer(context, child, container);
    }

    return container;
}

function getColumnStyles(context, widget) {
    const styles = {};
    const breakpoint = context.currentBreakpoint;

    const parentWidget = context.widgets.find(w => w.uid === widget.parent);
    if (!parentWidget || parentWidget.type !== "cleverstory.v2.widgets.section") {
        return styles;
    }

    styles.width = getColumnWidth(context, parentWidget, widget, breakpoint);
    styles.height = getColumnHeight(widget, breakpoint);

    return styles;
}

function getColumnWidth(context, sectionWidget, columnWidget, breakpoint) {
    const sectionProps = sectionWidget.properties[breakpoint];
    const columnSpacing = sectionProps.columnSpacing || 0;

    const columns = context.widgets.filter(w => w.parent === sectionWidget.uid).length;
    const totalWidth = 1200;

    const layout = columnWidget.properties[breakpoint].layout;
    const rawWidth = layout?.width || "";

    let width = 0;

    if (breakpoint === 'mobile'){
        return '100%';
    }

    if (rawWidth.endsWith("%")) {
        const percent = parseFloat(rawWidth);
        if (!isNaN(percent)) {
            width = (percent / 100) * totalWidth;
        }
    } 
    else if (rawWidth.endsWith("px")) {
        const px = parseFloat(rawWidth);
        if (!isNaN(px)) {
            width = px;
        }
    }

    if (!width) {
        width = totalWidth / columns;
    }

    if (columnSpacing > 0) {
        width = width - (2 * columnSpacing);
    }

    return `${Math.max(width, 0)}px`;
}

function getColumnHeight(sectionWidget, breakpoint) {
    const layout = sectionWidget.properties[breakpoint].layout;
    return layout?.height || "400px";
}

function renderColumnBackground(context, widget, element) {
    const props = widget?.properties?.desktop;
    if (!props?.background) return;

    renderBackground(context, widget, element);
}